import {Component, Injector} from '@angular/core';
import {BaseDynamicFormControl} from '../../../base-dynamic-form-control';
import {ImageService} from '../../../../../services/image.service';
import {RadioButtonGroupDynamicControlModel} from './radiobutton-group-dynamic-control.model';
import {RadioGroupOption} from './radio-group-option.model';

@Component({
    selector: 'app-radiobutton-group-dynamic-form-control',
    templateUrl: './radiobutton-group-dynamic-form-control.component.html',
    styleUrls: ['./radiobutton-group-dynamic.component.scss']
})
export class RadioButtonGroupDynamicFormControlComponent extends BaseDynamicFormControl<string> {

    infoIcon: string;
    options: RadioGroupOption[];

    private imageService: ImageService;

    constructor(
        injector: Injector
    ) {
        super(injector);
        this.imageService = injector.get(ImageService);
    }

    doInit() {
        this.infoIcon = this.imageService.getImage('INFO-ICON');
        this.options = (this.dynamicControlModel as unknown as RadioButtonGroupDynamicControlModel).options;
    }

    updateFormControlValue(inputValue: any) {
        // TODO - Implement me
    }

    clearValue() {
        this.dynamicControlModel.value = null;
    }

}
